import React from 'react';
import { useTranslation } from 'react-i18next';
import Page from '../../core/components/Page';
import Layout from '../../core/components/Layout.tsx';
import SettingsNavigation from '../../core/components/SettingsNavigation.tsx';
import PlanUsageCard from '../components/PlanUsageCard.tsx';

const CustomerPlanUsagePage = () => {
    const { t } = useTranslation('customer');

    return (
        <Layout>
            <SettingsNavigation />

            <Page className="flex-1">
                <Page.Header className="justify-between">
                    <Page.HeaderTitle>{t('planUsage.title')}</Page.HeaderTitle>
                </Page.Header>

                <Page.Content lowered className="flex flex-col gap-6 relative">
                    <PlanUsageCard />
                </Page.Content>
            </Page>
        </Layout>
    );
};

export default CustomerPlanUsagePage;
